import _ from 'lodash';
import React from 'react';

import Loading from 'components/Loading';
import Table from 'components/Table';
import ErrorBlock from 'components/ErrorBlock';
import ImageWithFilename from 'components/ImageWithFilename';

import Dropzone from 'components/Dropzone';
import {UploadFilePlaceholder, WrongFormat} from 'components/SingleFileUpload';

import {EmptyListPlaceholder} from 'containers/BookingSetDetail/components';

import {formatDate} from 'utils/datetime';
import {headOption} from 'utils/common';

import imageIcon from 'assets/icons/image-icon.svg';
import {ACCEPTED_IMAGE_FILE_TYPES} from 'ducks/files';

import './styles.css';

interface ImageProp {
  id: number;
  imageUrl: string;
  filename: string;
  createdAt: string;
  fileType: string;
  addedBy: string;
}

interface RoomCheckDetailImagesSectionProps {
  images: Array<ImageProp>;
  uploadingImage: boolean;
  removeImage: ({imageId: number}) => any;
  dropImage: ({image: any}) => any;
  imageUploadError?: string;
}

const ImageRow = ({image, removeImage}) => (
  <Table.Row>
    <Table.Cell className="filename">
      <a href={image.imageUrl} target="_blank">
        <ImageWithFilename
          imageUrl={image.imageUrl}
          filename={image.filename}
        />
      </a>
    </Table.Cell>
    <Table.Cell className="filetype">{image.fileType}</Table.Cell>
    <Table.Cell className="createdAt">{formatDate(image.createdAt)}</Table.Cell>
    <Table.Cell className="addedBy">{image.addedBy}</Table.Cell>
    <Table.Cell
      className="remove colab-bold"
      onClick={() => removeImage({imageId: image.id})}>
      Remove
    </Table.Cell>
  </Table.Row>
);

// This component will be used for Arrival  & DepartureRoomChecks
class RoomCheckDetailImagesSection extends React.Component<
  RoomCheckDetailImagesSectionProps
> {
  state = {
    imageWrongFormat: false
  };

  onImageDrop = images => {
    if (_.isEmpty(images)) {
      return this.setState({imageWrongFormat: true});
    }

    this.setState({
      imageWrongFormat: false
    });
    const image = headOption(images);

    this.props.dropImage({image});
  };

  render() {
    const {images = [], uploadingImage, imageUploadError} = this.props;
    const {imageWrongFormat} = this.state;
    const imagesData = _.values(images);

    return (
      <div className="RoomCheckDetailImagesSection">
        <div className="RoomCheckDetailImagesSection__header colab-bold">
          Images
        </div>
        {imageUploadError && <ErrorBlock>{imageUploadError}</ErrorBlock>}
        <div className="RoomCheckDetailImagesSection__table">
          <Table>
            <Table.Header>
              <Table.HeaderItem heading="Filename" className="filename" />
              <Table.HeaderItem heading="Type" className="filetype" />
              <Table.HeaderItem heading="Uploaded" className="createdAt" />
              <Table.HeaderItem heading="Uploaded by" className="addedBy" />
              <Table.HeaderItem className="remove" />
            </Table.Header>
          </Table>

          {uploadingImage && <Loading />}

          {!uploadingImage && _.isEmpty(imagesData) && <EmptyListPlaceholder />}

          {!uploadingImage &&
            !_.isEmpty(imagesData) && (
              <Table>
                <Table.Body>
                  {imagesData.map(image => (
                    <ImageRow
                      key={image.id}
                      image={image}
                      removeImage={this.props.removeImage}
                    />
                  ))}
                </Table.Body>
              </Table>
            )}
        </div>
        {/*TODO: The className FileUpload will be deleted when UploadFilePlaceholder is created a common component*/}
        <div className="RoomCheckDetailImagesSection__upload FileUpload">
          <Dropzone
            onDrop={this.onImageDrop}
            multiple={false}
            acceptedFileTypes={ACCEPTED_IMAGE_FILE_TYPES}
            defaultComponent={
              <React.Fragment>
                {imageWrongFormat && <WrongFormat />}
                {!imageWrongFormat && (
                  <UploadFilePlaceholder
                    placeholderIcon={imageIcon}
                    placeholderText={'Upload images'}
                  />
                )}
              </React.Fragment>
            }
          />
        </div>
      </div>
    );
  }
}

export default RoomCheckDetailImagesSection;
